import _ from 'lodash'
import { Score } from '@app/constants'

export const maxScore = (objects) => Score.max * objects.length

export const totalScore = (objects) => {
  return _.sumBy(objects, (task) => _.get(task, 'answer.score', Score.min))
}

export const timeSpent = (objects) => {
  return _.sumBy(objects, (task) => _.get(task, 'answer.time', 0))
}

export const statePath = (ability) => {
  if ( ability.can('read', 'ResultsPage') ) {
    return '/students/results/tasks'
  }

  if ( ability.cannot('participate', 'Olympiad') ) {
    return '/students/inappropriate_grade'
  }

  if ( ability.can('start', 'Tour', 'preparatory') ) {
    return '/students/tours/preparatory/start'
  }

  if ( ability.can('solve', 'Tour', 'preparatory') ) {
    return '/students/tasks/preparatory'
  }

  if ( ability.can('start', 'Tour', 'trial') ) {
    return '/students/tours/trial/start'
  }

  if ( ability.can('solve', 'Tour', 'trial') ) {
    return '/students/tasks/trial'
  }

  if ( ability.can('solve', 'Tour', 'main') ) {
    return '/students/tasks/main'
  }

  if ( ability.can('start', 'Tour', 'main') ) {
    return '/students/tours/main/intro'
  }

  if ( ability.can('read', 'Score', 'rewarding') ) {
    return '/students/results/rewarding'
  }

  return '/students/coming_soon'
}
